import { render, staticRenderFns } from "./TasksHeader.vue?vue&type=template&id=fb3df6ce&scoped=true"
import script from "./TasksHeader.vue?vue&type=script&lang=js"
export * from "./TasksHeader.vue?vue&type=script&lang=js"
import style0 from "./TasksHeader.vue?vue&type=style&index=0&id=fb3df6ce&prod&lang=scss&scoped=true"
import style1 from "./TasksHeader.vue?vue&type=style&index=1&id=fb3df6ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3df6ce",
  null
  
)

export default component.exports